module.exports = __webpack_public_path__ + "static/media/undraw_android_jr64.145779aa.svg";